import { ListSubheader, Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import type { DimensionDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import {
  selectDimensionsForCurrentReportType,
  selectDimensionsStructureForCurrentReportType,
} from "../../../../store/selectors/metaDataSelectors.ts";
import { getStructureDimensions } from "../utils/statementColumns.ts";

interface Props {
  anchorEl: HTMLElement;
  onPick: (dimension: DimensionDescriptor) => void;
  onClose: () => void;
}

const AddAxisMenu = ({ anchorEl, onPick, onClose }: Props) => {
  const dimensions = useSelector(selectDimensionsForCurrentReportType);
  const structure = useSelector(selectDimensionsStructureForCurrentReportType);

  return (
    <Menu open anchorEl={anchorEl} onClose={onClose}>
      <ListSubheader sx={{ lineHeight: 2, bgcolor: "transparent" }}>Column Axis</ListSubheader>
      {getStructureDimensions(dimensions, structure).map((dimension) => (
        <MenuItem key={dimension.name} onClick={() => onPick(dimension)}>
          {dimension.isNew ? `${dimension.caption} (New)` : dimension.caption}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default AddAxisMenu;
